export default __webpack_public_path__ + "static/roaming-setup-3f83dee6e3f559faca536fb59aafa0d8.png";